// extracted by mini-css-extract-plugin
export default {"Instruction":"instruction_Instruction__3UEgs","minusTypeList":"instruction_minusTypeList__5plQL"};